export default "__VITE_PUBLIC_ASSET__29274677__"